const newsletterSections = document.querySelectorAll('.section.ott-newsletter-box');

if (newsletterSections.length > 0) {
  const revealSection = (entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      return true;
    }
    return false;
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (revealSection(entry)) {
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    newsletterSections.forEach((section) => observer.observe(section));
  } else {
    newsletterSections.forEach((section) => section.classList.add('is-visible'));
  }
}
